import styled from "styled-components";
import { Card } from "antd";

export const SectionCard = styled(Card)`
  border: none;
  margin-bottom: 16px;
`;

export const SectionTitle = styled.span`
  display: inline-block;
  font-weight: 600;
  font-size: 20px;
  background: linear-gradient(to right, #004b6b, #00b0f0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  position: relative;
  padding-bottom: 4px;
  margin-bottom: 12px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    width: 100%;
    background: linear-gradient(to right, #004b6b, #00b0f0);
    border-radius: 2px;
  }
`;

